export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd112020',
  loginNameProject: 'BIODIGESTOR POMERODE',
  sideNameProject: 'BIO POMERODE',
  exibirGraficoInicial: true,
  iconeInterno: '../static/img/bi-logo-archea-biogas2.svg'
}



// WEBPACK FOOTER //
// ./src/config/index.js